import { render, staticRenderFns } from "./ProductImagePopup.vue?vue&type=template&id=3a6b29c7&"
import script from "./ProductImagePopup.vue?vue&type=script&lang=js&"
export * from "./ProductImagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports